import firebase from 'firebase'

const config = {
  apiKey: "AIzaSyD-zML_pZLidgcgsVnhNAcfpon3Y8au4h0",
  authDomain: "timer-app-pwa-27dd2.firebaseapp.com",
  projectId: "timer-app-pwa-27dd2",
  storageBucket: "timer-app-pwa-27dd2.appspot.com",
  messagingSenderId: "972245964715",
  appId: "1:972245964715:web:f78130ebcf7f46f6aa64ee",
  measurementId: "G-5JSF7NWE3C"
  };

firebase.initializeApp(config);
const messaging = firebase.messaging();

export function configNotification() {
    
  Notification.requestPermission().then((permission) => {
      messaging.getToken().then((currentToken) => {
        alert(currentToken);
        prompt('token', currentToken);
        console.log(currentToken)
        
        if (currentToken) {
        } else {
          // Show permission request.
          console.log('No registration token available. Request permission to generate one.');

        }
      }).catch((err) => {
        console.log('An error occurred while retrieving token. ', err);

      });
  
  
  })

}